import React from 'react';
import { FaFlag, FaCheck } from 'react-icons/fa';

export const InactiveFlag = (props) => {
  let { flag } = props;
  if (flag) return <FaFlag color="red" />;
  else return <FaCheck color="green" />;
};
